import { render, staticRenderFns } from "./ContentTypeTextWImage.vue?vue&type=template&id=6bc21031&scoped=true&"
import script from "./ContentTypeTextWImage.vue?vue&type=script&lang=js&"
export * from "./ContentTypeTextWImage.vue?vue&type=script&lang=js&"
import style0 from "./ContentTypeTextWImage.vue?vue&type=style&index=0&id=6bc21031&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc21031",
  null
  
)

export default component.exports